export default "__VITE_ASSET__DQCqAdPE__"